export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10729.c0aba66b.jpg";